import { z } from 'zod';
import { PartnerLeadSchema } from '../../entities/partner/partner.schema';
/**
 * Which leads the response contains, derived server-side from the caller's role:
 * - 'all'  : partner_admin — every employee's leads of the partner company
 * - 'mine' : partner_staff — only the caller's own acquired leads
 */ export const PartnerLeadsScopeSchema = z.enum([
    'all',
    'mine'
]);
/**
 * List Partner Leads Response Schema
 * GET /api/v2/partner/leads
 * Returns the leads of the authenticated partner company. The partner company
 * and the caller's role are resolved server-side from the JWT — never from a
 * client value.
 */ export const ListPartnerLeadsResponseSchema = z.object({
    /** Whether these are all the company's leads or just the caller's own. */ scope: PartnerLeadsScopeSchema,
    leads: z.array(PartnerLeadSchema),
    meta: z.object({
        total: z.number(),
        generatedAt: z.string()
    })
});

//# sourceMappingURL=list-partner-leads.schema.js.map